<template>
  <nav class="flex flex-wrap gap-2 mb-4" aria-label="Coaching navigation">
    <router-link
      v-if="chatVisible"
      to="/coaching"
      class="px-4 py-2 rounded-lg text-sm font-medium transition-colors"
      :class="isChat
        ? 'text-white shadow-sm'
        : 'bg-white border border-gray-200 text-gray-700 hover:border-[var(--color-orange)]'"
      :style="isChat ? { background: 'var(--accent-gradient)' } : undefined"
    >
      <i class="pi pi-comments mr-1.5" />
      {{ $t('Coaching.navChat') }}
    </router-link>
    <router-link
      v-if="chatVisible"
      to="/coaching/profiling"
      class="px-4 py-2 rounded-lg text-sm font-medium transition-colors"
      :class="isProfiling
        ? 'text-white shadow-sm'
        : 'bg-white border border-gray-200 text-gray-700 hover:border-[var(--color-orange)]'"
      :style="isProfiling ? { background: 'var(--accent-gradient)' } : undefined"
    >
      <i class="pi pi-id-card mr-1.5" />
      {{ $t('Coaching.navProfiling') }}
    </router-link>
    <router-link
      v-if="profileVisible"
      to="/coaching/profile"
      class="px-4 py-2 rounded-lg text-sm font-medium transition-colors"
      :class="isProfile
        ? 'text-white shadow-sm'
        : 'bg-white border border-gray-200 text-gray-700 hover:border-[var(--color-orange)]'"
      :style="isProfile ? { background: 'var(--accent-gradient)' } : undefined"
    >
      <i class="pi pi-user mr-1.5" />
      {{ $t('Coaching.navProfile') }}
    </router-link>
  </nav>
</template>

<script>
import { isFeatureVisibleForCustomer } from '@/utils/featureAccess';

export default {
  name: 'CoachingSubNav',
  props: {
    active: {
      type: String,
      default: 'chat',
      validator: (v) => ['chat', 'profile', 'profiling'].includes(v),
    },
  },
  computed: {
    isProfiling() {
      return this.active === 'profiling';
    },
    isChat() {
      return this.active === 'chat';
    },
    isProfile() {
      return this.active === 'profile';
    },
    chatVisible() {
      return isFeatureVisibleForCustomer(this.$store, 'llmCoaching');
    },
    profileVisible() {
      return isFeatureVisibleForCustomer(this.$store, 'llmCoachingProfile');
    },
  },
};
</script>
